export const createShipmentEndpoint = '/shipments' as const
